import { render, staticRenderFns } from "./personal-massage.vue?vue&type=template&id=874fd714&scoped=true&"
import script from "./personal-massage.vue?vue&type=script&lang=js&"
export * from "./personal-massage.vue?vue&type=script&lang=js&"
import style0 from "./personal-massage.vue?vue&type=style&index=0&id=874fd714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874fd714",
  null
  
)

export default component.exports